import { render, staticRenderFns } from "./NoteTextArea.vue?vue&type=template&id=14165568&"
import script from "./NoteTextArea.vue?vue&type=script&lang=js&"
export * from "./NoteTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports